// src/components/reports/visibleClients.js
//
// Which clients the Monthly Reports page shows under the current filter.
//
// ⛔ ONE DEFINITION, because two things depend on it: the client CARDS, and the
// "Generate all (N visible)" button's count AND target set. A button that says
// N and generates a different N is worse than no button — it would silently
// regenerate a client nobody was looking at, overwriting that client's pack and
// re-freezing its snapshots.

/* ⚠ Mirrors REPORTED_TIERS in the backend's reportSections.js. Copper and Adhoc
   are deliberately absent — they receive no monthly report at all. */
export const REPORTED_TIERS = ["Bronze", "Silver", "Gold"];

/**
 * @param companies    [{ id, companyName, _tier }] — `_tier` is the RESOLVED
 *                     tier from /companies-with-tiers (Craig's manual override
 *                     where set, the contract-name derivation otherwise).
 * @param managedSet   Set of managed company ids, or null/empty for "all".
 * @param tierFilter   "All" | "Bronze" | "Silver" | "Gold"
 */
export function visibleReportClients(companies, { managedSet, tierFilter = "All" } = {}) {
  return [...(companies || [])]
    .filter((c) => (managedSet && managedSet.size ? managedSet.has(String(c.id)) : true))
    /* ⛔ THIS FILTER RUNS BEFORE THE DROPDOWN, and that ordering is what makes
       Adhoc and Copper unreachable — including under "All plans". They are not
       "skipped" by the bulk button; they are never in the list for it to skip.
       "This plan has no report" and "this plan's report is empty" are different
       things and only the first is true. */
    .filter((c) => REPORTED_TIERS.includes(String(c._tier)))
    .filter((c) => (tierFilter === "All" ? true : String(c._tier) === tierFilter))
    .sort((a, b) => String(a.companyName || "").localeCompare(String(b.companyName || "")));
}
